import React, { Fragment } from 'react'
import HeaderBotton from '../../../components/HeaderBottom'
import HeaderTop from '../../../components/HeaderTop'
import Breadcumb from '../../../components/Breadcumb'
import NewsLetter from '../../../components/Newsletter'
import FooterArea from '../../../components/FooterArea'
import Portfolio from '../../../components/Portfolio'
import ContactArea from '../../../components/ContactArea'

// images
import breadcumb from '../../../images/breadcumb/1.jpg'
import team from '../../../images/Attorneys-single/1.jpg'
import portfolio1 from '../../../images/studies/1.jpg'
import portfolio2 from '../../../images/studies/2.jpg'
import portfolio3 from '../../../images/studies/3.jpg'

import './style.scss'

const breadcumbMenu = [
    { name: 'Home', route: '/' },
    { name: 'Team', route: '/team' },
    { name: 'Team Details' }
]
const teamMembarInfo = [
    { level: 'Phone: ', text: '858.775.1775' },
    { level: 'Email: ', text: 'kimberly@ziermanestradalaw.com' },
]
const teamContents = [

]

const portfolioItem = [
    { images: portfolio1, title: 'General Service', subtitle: 'Corporate' },
    { images: portfolio2, title: 'Personal Issue', subtitle: 'General' },
    { images: portfolio3, title: 'Business Accounting', subtitle: 'Business' },
]

const SingleTeamPageKim = () => {
    return (
        <Fragment>
             <header className="headerArea">
                <HeaderBotton className="headerBottomArea" />
            </header>
            <Breadcumb
                className="breadcumbArea"
                title="Our Team"
                breadcumbMenu={breadcumbMenu}
                background={breadcumb}
            />
            <div className='singleTeamArea'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-12">
                            <div className="row">
                                <div className="col-md-4 col-12">
                                    <div className="singleTeamImgWrap">
                                        <h4>Kimberly Zierman</h4>
                                        <div className="singleTeamImg">
                                            <img src={team} alt=""/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-12">
                                    <div className="singleTeamInfo">
                                        <h3>Personal Experience</h3>
                                        <p>Kimberly views estate planning as one of the greatest gifts families can give their loved ones.  She is passionate about finding practical solutions that will communicate your values and create a lasting legacy while guiding your chosen representative as they navigate the transfer and management of assets. Kimberly is a graduate of the University of San Diego (BA) and Thomas Jefferson School of Law (JD).  She worked as a California Deputy Attorney General in the civil division before stepping away to stay home with her three daughters.  Kimberly continued her legal education focusing on wills, trusts and estate planning while serving in a variety of volunteer positions in her community. It has been her great honor to serve as trustee to multiple families.</p>
                                        <ul>
                                            {teamContents.map(teamContent => (
                                                <li key={teamContent}>{teamContent}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                            <div className="col-12">
                                <div className="singleTeamContent">
                                    <h4>Contact Information</h4>
                                    <ul className="teamMembarInfo">
                                        {teamMembarInfo.map((teamInfo, i) => (
                                            <li key={i}>
                                                <span>{teamInfo.level} {teamInfo.text}</span>
                                            </li>
                                        ))}
                                    </ul>
                                    <ul className="socialShare">
                                        <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    <ContactArea
        className="contactArea"
    />

    <FooterArea/>
</Fragment>
)
}
export default SingleTeamPageKim